
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import { Provider } from '@/types';
import TextField from '@/components/shared/TextField.vue';

@Component<DeliveryOpenAddress>({
	components: {
		ValidationProvider,
		TextField
	}
})
export default class DeliveryOpenAddress extends Vue {
	@Prop({ type: Object, required: true }) private deliveryInformation!: DeliveryInfo;

	$refs!: {
		addressValidation: Provider;
	};

	private delivery: DeliveryInfo = {
		type: 'open_address',
		address: ''
	};

	private mounted(): void {
		if (this.deliveryInformation) {
			this.delivery = {
				...this.deliveryInformation,
				type: 'open_address'
			};
		}
	}

	private updateDeliveryInfo(): void {
		this.$refs.addressValidation.validate();
		this.$emit('delivery-info-updated', this.delivery);
	}
}
